import React, { FC } from 'react';
import s from './listDateItem.module.scss';
import moment from 'moment/moment';
interface Props {
  date: Date;
}
export const ListDateItem: FC<Props> = ({
  date
}) => {
  return <div className={s.listDateItem} data-sentry-component="ListDateItem" data-sentry-source-file="ListDateItem.tsx">
            {moment(date).format('DD.MM.YYYY')}
        </div>;
};